import { ChangeDetectorRef, Component, inject, Input } from '@angular/core';
import { AbstractControl, FormArray, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';

import { MatButton, MatIconButton } from '@angular/material/button';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { GlobalMetadataFactoryService } from '../../../services/global-metadata.factory.service';

@Component({
  selector: 'pixl-form-dialog-global-metadata-icon-selection',
  templateUrl: './form-dialog-global-metadata.icon-selection.component.html',
  imports: [
    MatFormField,
    ReactiveFormsModule,
    FormsModule,
    MatLabel,
    MatButton,
    MatSelect,
    MatOption,
    MatIcon,
    MatIconButton
  ]
})
export class FormDialogGlobalMetadataIconSelectionComponent {
  @Input() parentGroup!: FormGroup;

  cdr = inject(ChangeDetectorRef);

  private metaFactory = inject(GlobalMetadataFactoryService);

  nameOptions = ['grusiAnforderungsSymbols', 'iconSetName'];

  get options(): FormArray {
    return this.parentGroup.get('subFieldConf') as FormArray;
  }

  getSubFieldConf(group: FormGroup): FormArray {
    return group.get('subFieldConf') as FormArray;
  }

  getFormGroup(control: AbstractControl | null): FormGroup | null {
    return control && control instanceof FormGroup ? (control as FormGroup) : null;
  }

  addSubField(group: FormGroup) {
    const newGroup: FormGroup = this.metaFactory.createFieldConfGroup({
      name: this.nameOptions[0],
      label: 'IconSet',
      datatype: 'String',
      subFieldConf: [],
    });

    setTimeout(() => {
      this.getSubFieldConf(group).push(newGroup);
      this.cdr.detectChanges();
    }, 0);
  }

  removeSubField(array: FormArray, index: number) {
    array.removeAt(index);
  }
}
